import GuideRow from "../../../GuideRow";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import GuideVlessLinkData from "components/guides/GuideVlessLinkData";
import GuideVlessQrData from "components/guides/GuideVlessQrData";

const LinuxGuide = ({ subscription, servers = [] }) => {
  const navigate = useNavigate();
  const { t, _ } = useTranslation();
  if (!subscription) {
    return;
  }

  return (
    <>
      <GuideRow
        number="1"
        text={t("Install the Happ app")}
        action={
          <div className="column">
            <a
              className="link mb-1 mt-05"
              href="https://github.com/Happ-proxy/happ-desktop/releases/latest/download/Happ.linux.x64.deb"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("Download")} .deb
            </a>
            <a
              className="link mb-1"
              href="https://github.com/Happ-proxy/happ-desktop/releases/latest/download/Happ.linux.x64.rpm"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("Download")} .rpm
            </a>
            <a
              className="link"
              href="https://github.com/Happ-proxy/happ-desktop/releases/latest/download/Happ.linux.x64.pkg.tar.zst"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("Download")} .pkg
            </a>
          </div>
        }
      />
      <GuideRow
        number="2"
        text={t("Open Happ and import the configuration file")}
        actionPaddingLeft="none"
        action={
          <>
            <GuideVlessLinkData
              subscription={subscription}
              label={t("Subscription link")}
            />
            <GuideVlessQrData
              subscription={subscription}
              label={t("Subscription QR code")}
            />
          </>
        }
      />
    </>
  );
};

export default LinuxGuide;
